import {clientePedido} from '../../apiClient/index'

const moduloPedidosADistribuidores = {
    namespaced: true,
    state: {
        filtrosPedido: {},
        plazosPago: undefined
      },
    actions: {
        getPedidos(context, payload) 
    {
      return new Promise((resolve) => {
        clientePedido.get('/api/PedidoADistribuidor/Find', { params: payload })
        .then(response => resolve(response.data))
      })
    },

    setFiltrosPedido(context, payload)
    {
      context.commit('setFiltrosPedido', payload)
    },

    iniciarPedido(context, payload) 
    {
      return new Promise((resolve) => {
        clientePedido.post(`/api/PedidoADistribuidor/Init?idUsuario=${payload.idUsuario}`)
        .then(response => resolve(response.data))
      })
    },

    confirmarPedido(context, payload) 
    {
      return new Promise((resolve)=> {
        clientePedido.post(`/api/PedidoADistribuidor/ConfirmarPedido?idPedido=${payload.id}`)
        .then(response => resolve(response.data))
      })
    },
    volverAIngreso(context, payload) 
    {
      return new Promise((resolve)=> {
        clientePedido.post(`/api/PedidoADistribuidor/VolverAIngreso?idPedido=${payload.id}`)
        .then(response => resolve(response.data))
      })
    },

    getPedido(context, payload) {      
      return new Promise((resolve)=> {
        clientePedido.get(`/api/PedidoADistribuidor/Get?id=${payload.id}&idUsuario=${payload.idUsuario}`)
        .then(response => resolve(response.data))
      })
    },

    getCabeceraPedido(context, payload) 
    {
      return new Promise((resolve) => 
      {
        clientePedido.get(`/api/Pedido/GetCabecera?id=${payload.id}&idUsuario=${payload.idUsuario}`)
        .then(response => resolve(response.data))
      })
    },

    anularPedido(context, payload) {
      return new Promise(resolve =>{
        clientePedido.post(`/api/Pedido/AnularPedido?id=${payload.id}`)
        .then(response => {
          var result = response.data
          resolve(result.CodigoResultado)
        })
      })
    },

    savePedido(context, payload) {      
      return new Promise((resolve, reject) => {
        clientePedido.post('/api/PedidoADistribuidor/Save', payload)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
      })
    },

    uploadArchivoDetalles(context, payload) {
      
      // armo el payload
      let formData = new FormData()
      formData.append('archivo', payload.file)

      // subo el archivo
      return new Promise((resolve, reject) => {
        clientePedido.post(`/api/PedidoADistribuidor/UploadArchivoDetalles?id=${payload.id}`, formData)
        .then(
          response => { resolve(response.data) },
          error => { reject(error) }
        )
      })
    },

    importarDetallesPedido(context, payload)
    {
      return new Promise((resolve) => {
        clientePedido.post(`/api/PedidoADistribuidor/ImportarDetallesPedido?id=${payload.id}&idUsuario=${payload.idUsuario}`)
        .then(response => resolve(response.data))
      })
    },

    descargarPedido(context, payload)
    {
      return new Promise((resolve) => {
        clientePedido.get('/api/Pedido/Descargar', {params: payload})
        .then(response => resolve(response.data))
      })
    },

    getPlazosPago(context) 
    {
      return new Promise((resolve) => 
      {
        // verifico si los plazos de pago fueron inicializados
        if(context.state.plazosPago !== undefined)
        {
          resolve(context.state.plazosPago)
        }

        else 
        {
          clientePedido.get('api/PedidoADistribuidor/GetPlazosPago')
          .then((response) => 
          {
            let data = response.data

            if(data.CodigoResultado === 0) 
            {
              let plazosPago = JSON.parse(data.Datos)
              context.commit('setPlazosPago', plazosPago)
              resolve(context.state.plazosPago)
            }
          })
        }
      })
    },

    eliminarPedido(context, payload){
      return new Promise(resolve =>{
        clientePedido.post(`/api/PedidoADistribuidor/EliminarPedido?id=${payload.id}&idUsuario=${payload.idUsuario}`)
        .then(response => {
          var result = response.data
          resolve(result)
        })
      })
    },
    },
    mutations: {
        setFiltrosPedido(state, payload)
        {
          state.filtrosPedido = payload
        },
    
        setPlazosPago(state, payload) 
        {
          state.plazosPago = payload
        }
    }
}

export default moduloPedidosADistribuidores;